export default "__VITE_ASSET__DxxRy7lt__"